<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <!-- Posts Listing -->
    <section>
      <h3 class="title-left-border">Gerenciamento dos planos premium</h3>
      <hr>
      <b-collapse
        :open="true"
        position="is-bottom"
        aria-id="contentIdForA11y1"
      >
        <a
          slot="trigger"
          slot-scope="props"
          aria-controls="contentIdForA11y1"
        >
          <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
          {{ !props.open ? 'Expandir' : 'Recolher' }}

        </a>

        <!-- <span class="column is-12"> -->
        <b-button
          class="mr-4 my-4"
          type="is-primary"
          native-type="submit"
          @click="openCreateModal"
        >
          Criar novo plano
        </b-button>
        <!-- </span> -->

        <!-- Paginated Table -->

        <div v-if="plans.length">
          <b-table
            :data="plans"
            :paginated="true"
            :per-page="perPage"
            :total="total"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            default-sort="plan.name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >

            <template slot-scope="props">
              <!-- Nome -->
              <b-table-column
                field="name"
                label="Nome"
                sortable
              >
                {{ props.row.name }}
              </b-table-column>

              <!-- Preço -->
              <b-table-column
                field="amountPerPayment"
                label="Preço"
                sortable
              >
                {{ props.row.amountPerPayment }}
              </b-table-column>

              <!-- Periodicidade -->
              <b-table-column
                field="period"
                label="Periodicidade"
                sortable
              >
                {{ periods[props.row.period] }}
              </b-table-column>

              <!-- Status -->
              <b-table-column
                field="active"
                label="Status"
                sortable
              >
                {{ props.row.active ? "Ativo" : "Suspenso" }}
              </b-table-column>

              <!-- Actions -->
              <b-table-column
                fields="id"
                label="Ações"
                width="150"
              >
                <b-button
                  type="is-danger"
                  @click="confirmDeactivatePlan(props.row.id)"
                  class="mr-2"
                >
                  <b-tooltip label="Desativar">
                    <b-icon icon="close-circle-outline" />
                  </b-tooltip>
                </b-button>
                <!--
                <b-button @click="setSelectedPlanAndOpenModal(props.row)">
                  <b-tooltip label="Editar">
                    <b-icon icon="square-edit-outline" />
                  </b-tooltip>
                </b-button>

 -->
              </b-table-column>

            </template>
          </b-table>
        </div>
        <div
          v-else
          class="text-center"
        >
          <h3>Nenhum Resultado Disponível</h3>
        </div>

        <!--- Paginated Table End -->
      </b-collapse>

      <b-modal
        has-modal-card
        :active.sync="isPlanEditModalOpened"
        trap-focus
        aria-role="dialog"
        aria-modal
      >
        <PlanEditModal
          :mode="modalMode"
          :planData="selectedPlan"
        ></PlanEditModal>
      </b-modal>
    </section>

  </div>
</template>

<script>
import { plansCollection } from '../../firebaseConfig'
import PlanEditModal from './PlanEditModal'
import { mapState } from 'vuex'

const periods = {
  MONTHLY: 'Mensal',
  WEEKLY: 'Semanal',
  BIMONTHLY: 'Bimestral',
  TRIMONTHLY: 'Trimestral',
  SEMIANNUALLY: 'Semestral',
  YEARLY: 'Anual'
}

export default {
  components: {
    PlanEditModal
  },
  data () {
    return {
      modalMode: 'create',
      selectedPlan: {
        name: '',
        amountPerPayment: '',
        period: 'MONTHLY'
      },
      isPlanEditModalOpened: false,
      currentPage: 1,
      perPage: 10,
      total: 0,
      performingRequest: false,
      periods
    }
  },
  computed: {
    ...mapState(['plans'])
  },
  async created () {
    this.fetchPlans()
  },
  methods: {
    async fetchPlans () {
      try {
        this.performingRequest = true
        await this.$store.dispatch('fetchPlans')
      } catch (error) {
        this.$toasted.error('Um erro ocorreu ao carregar os planos. Tente novamente mais tarde.')
      } finally {
        this.performingRequest = false
      }
    },
    handlePlanCreated: plan => this.fetchPlans(),
    setSelectedPlanAndOpenModal (planData) {
      this.modalMode = 'edit'
      this.selectedPlan = planData
      this.isPlanEditModalOpened = true
    },
    openCreateModal () {
      console.log('aqui')
      this.modalMode = 'create'
      this.isPlanEditModalOpened = true
    },
    confirmDeactivatePlan (id) {
      this.$buefy.dialog.confirm({
        title: 'Desativação de Plano',
        message: 'Tem certeza que deseja desativar este plano? <br/> Este plano apenas será ocultado para novos usuários. Usuários atuais permanecerão com o plano ativo.',
        confirmText: 'Desativar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deactivatePlan(id)
      })
    },
    async deactivatePlan (id) {
      try {
        this.performingRequest = true
        await plansCollection.doc(id).update({ active: false })
        this.$toasted.success('Plano desativado com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível desativar este plano. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
      }
    }
  }

}
</script>
<style>
.modal section {
  margin: unset !important;
}
.modal-background {
  background-color: rgba(10, 10, 10, 0.25) !important;
}
</style>
